<template>
  <div class="description zy_constr" :id="data.id">
    <div class="description-title">{{ data.title }}</div>
    <div class="description-desc" v-for="item in desc" :key="item">{{ item }}</div>
  </div>
</template>

<script>
import { isMobile } from '@/utils/utils';
export default {
  name: 'Description',
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    desc() {
      return isMobile() ? this.data.desc_wap || this.data.desc : this.data.desc;
    }
  }
};
</script>
<style lang="scss">
@import '@/styles/variables.scss';
@import '@/styles/function.scss';

.description {
  padding-top: 60px;
  padding-bottom: 48px;
}

.description-title {
  font-size: 40px;
  font-weight: 500;
  color: #000;
  line-height: 60px;
  text-align: center;
}

.description-desc {
  margin-top: 24px;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 28px;
}

.S {
  .description {
    padding: rem(72) 0;
  }
  .description-title {
    font-size: rem(60);
    line-height: rem(26 * 3);
  }
  .description-desc {
    margin-top: rem(72);
    font-size: rem(42);
    line-height: rem(75);
    padding: 0 rem(48);
  }
}

/* Android 特定样式 */
@supports not (-webkit-touch-callout: none) {
    .S .description-title {
        font-weight: bold;
    }
}
</style>
